import { Box, Collapse, Grid } from "@material-ui/core";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import KeyboardArrowUp from "@material-ui/icons/KeyboardArrowUp";
import MyTypography from "@saleor/components/MyTypography";
import { makeStyles } from "@saleor/macaw-ui";
import classNames from "classnames";
import React, { FC, useMemo, useState } from "react";
export interface CollapseSoldToProps {
  name: string;
  index: number;
}

const useStyles = makeStyles(
  () => ({
    container: {
      marginBottom: "1.6rem",
      borderRadius: 8,
      boxShadow: `0px 4px 16px rgba(0, 0, 0, 0.12)`,
      background: "#FFFFFF",
      cursor: "pointer"
    },
    header: {
      display: "flex",
      justifyContent: "space-between",
      padding: "21px 32px",
      alignItems: "center"
    },
    collapse: { padding: "0 32px" },
    inlineBlock: {
      display: "inline-block"
    },
    soldTo: { marginRight: 6 },
    mb20: {
      marginBottom: 20
    }
  }),
  { name: "CollapseSoldTo" }
);

const CollapseSoldTo: FC<CollapseSoldToProps> = ({ children, name, index }) => {
  const classes = useStyles();
  const [isOpen, setIsOpen] = useState<boolean>(!index);
  const ArrowIconComponent = useMemo(
    () => (isOpen ? KeyboardArrowUp : KeyboardArrowDown),
    [isOpen]
  );

  return (
    <Box className={classes.container}>
      <Grid
        className={classes.header}
        container
        onClick={() => setIsOpen(!isOpen)}
      >
        <Box>
          <MyTypography
            variant="subtitle3"
            className={classNames(classes.inlineBlock, classes.soldTo)}
          >
            {isOpen ? "Sold-to Party" : "Sold to"}
          </MyTypography>
          <MyTypography variant="body3" className={classes.inlineBlock}>
            {name}
          </MyTypography>
        </Box>
        <ArrowIconComponent />
      </Grid>
      <Collapse className={classes.collapse} in={isOpen}>
        {children}
      </Collapse>
    </Box>
  );
};

export default CollapseSoldTo;
